import gql from 'graphql-tag';

export const GET_TASK = gql`
  query getTask($taskId: ID!, $module: String!, $isItProduct: Boolean!) {
    getTask(taskId: $taskId, module: $module) {
      createdTime
      taskId
      displayId
      title
      description
      status
      priority
      estimatedTime
      scheduledStartDate
      dueDate
      overdue
      actualStartDate
      actualEndDate
      technician {
        userId
        name
        email
        firstName
        lastName
      }
      milestone {
        milestoneId
      }
      techGroup {
        name
        groupId
      }
      ticket {
        ticketId
        subject
        displayId
        loggedInUserAsFollower {
          ticketPermission
        }
      }
      module
      project {
        projectId
        title
        loggedInUserRole {
          roleId
        }
      }
      workItem {
        workId
        displayId
        subject
        module
        client {
          accountId
          name
        }
        site {
          name
          id
        }
        ticket @skip(if: $isItProduct) {
          contractTicketMapping {
            contractId
            contract {
              contractId
            }
            inUse
          }
        }
        project @skip(if: $isItProduct) {
          contract {
            contractId
          }
        }
      }
      ticketPermission
    }
  }
`;
